export function AccountNavSkeleton() {
  return <div className="h-8 w-8 animate-pulse rounded-full bg-secondary" />;
}
